import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Breadcrumbs from 'core/components/SecondaryHeader'
import {Wrapper} from './components/Styled'
import LazyImage from 'core/components/LazyImage'
import Slider from 'react-slick'
import PuppySeekerNav from '../PuppySeekerNav'

function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className="next_arrow"
        onClick={onClick}>
            &#8963;
      </div>
    );
}

function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className="prev_arrow"
        onClick={onClick}>
            &#8963;
      </div>
    );
}

class PuppyResources extends Component {

  static defaultProps = {
    cms: {},
  }

  static propTypes = {
    cms: PropTypes.object.isRequired,
  }

  getLeftItems () {
    return [
      {
        text: 'Home',
        isLink: true,
        isActive: true,
        props: {
          href: '/'
        }
      },
      {
        text: 'Resources for Getting a Dog',
        isLink: false,
        isActive: false,
        props: {
          href: '/'
        }
      }
    ]
  }

  removeHTMLtags( string ) {
    let regex = /(<([^>]+)>)/ig
    return (string) ? string.replace(regex, "") : ''
  }  

  render () {

    const settings = {
        arrows: true,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,        
    };

    return (
      <div>
        <div className='marketplace__top-image'>

          <Breadcrumbs items={ this.getLeftItems() }  />

        </div>

        <Wrapper className={`static-page`}>
          <div className='static-page__section'>
            <div className='header' >
                <h1> { this.removeHTMLtags( this.props.cms['about-marketplace-heading'] ) } </h1>
            </div>

            <PuppySeekerNav />

            <div className='section-1' >
                <div className='img-wrap' >
                    <LazyImage src={  this.removeHTMLtags( this.props.cms['about-marketplace-section-1-image'] )  }  className='section-1-img' />
                </div>
                <div className='text-wrap' >
                    <h2> { this.removeHTMLtags( this.props.cms['about-marketplace-section-1-heading'] ) } </h2>
                    <p dangerouslySetInnerHTML={{ __html:  this.props.cms['about-marketplace-section-1-text']  }} /> 
                    <a className="button"  href={ this.removeHTMLtags( this.props.cms['about-marketplace-section-1-button-link'] ) } target="_blank" >
                        { this.removeHTMLtags( this.props.cms['about-marketplace-section-1-button-text']) }
                    </a>
                </div>
            </div>

            <div className='section-2' >
                <div className='text-wrap' >
                    <h2> { this.removeHTMLtags( this.props.cms['about-marketplace-section-2-heading'] )} </h2>
                    <p dangerouslySetInnerHTML={{ __html:  this.props.cms['about-marketplace-section-2-text']  }} /> 
                    <p>
                        <a className='section-link' target="_blank" href={ this.removeHTMLtags( this.props.cms['about-marketplace-section-2-link'] ) } >
                            { this.removeHTMLtags( this.props.cms['about-marketplace-section-2-link-text'] ) }
                        </a>
                    </p>           
                </div>                
                <div className='img-wrap' >
                    <LazyImage src={ this.removeHTMLtags( this.props.cms['about-marketplace-section-2-image'] ) }  className='section-2-img' />
                </div>
            </div>

            <div className='section-3' >
                <div className='text-wrap' >
                    <h2> { this.removeHTMLtags( this.props.cms['about-marketplace-section-3-heading'] ) } </h2>
                    <p className='sub-heading' >
                        <span>  { this.removeHTMLtags( this.props.cms['about-marketplace-section-3-text'] ) }</span>
                    </p>
                </div>

                <div className='mobile-slider' >
                    <Slider {...settings}>
                        <div>
                            <div>
                                <LazyImage src={  this.props.cms['about-marketplace-section-3-logo-1']  } className='section-3-logo' />
                                <a target="_blank" href={ this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-1-link'] ) } >
                                    { this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-1-title'] ) }
                                </a>
                            </div>
                        </div>
                        <div>
                            <div>
                                <LazyImage src={  this.props.cms['about-marketplace-section-3-logo-2']  } className='section-3-logo' />
                                <a target="_blank" href={ this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-2-link'] ) } >
                                    { this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-2-title'] ) }
                                </a>
                            </div>
                        </div>
                        <div>
                            <div>
                                <LazyImage src={  this.props.cms['about-marketplace-section-3-logo-3']  } className='section-3-logo' />
                                <a target="_blank" href={ this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-3-link'] ) } >
                                    { this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-3-title'] ) }
                                </a>
                            </div>
                        </div>
                    </Slider>
                </div>

                <div className='img-wrap' >
                    <div>
                        <LazyImage src={  this.props.cms['about-marketplace-section-3-logo-1']  } className='section-3-logo' />
                        <a target="_blank" href={ this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-1-link'] ) } >
                            { this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-1-title'] ) }
                        </a>
                    </div>
                    <div>
                        <LazyImage src={  this.props.cms['about-marketplace-section-3-logo-2']  } className='section-3-logo' />
                        <a target="_blank" href={ this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-2-link'] ) } >
                            { this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-2-title'] ) }
                        </a>
                    </div>
                    <div>
                        <LazyImage src={  this.props.cms['about-marketplace-section-3-logo-3']  } className='section-3-logo' />
                        <a target="_blank" href={ this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-3-link'] ) } >
                            { this.removeHTMLtags( this.props.cms['about-marketplace-section-3-logo-3-title'] ) }
                        </a>
                    </div>                  
                </div>
            </div>

            <div className='section-4' >
                <div className='img-wrap' >
                    <LazyImage src={  this.removeHTMLtags( this.props.cms['about-marketplace-section-4-image'] )  }  className='section-4-img' />
                </div> 
                <div className='text-wrap' >
                    <h2> { this.removeHTMLtags( this.props.cms['about-marketplace-section-4-heading'] )} </h2>
                    <p dangerouslySetInnerHTML={{ __html:  this.props.cms['about-marketplace-section-4-text']  }} /> 
                    <p>
                        <a target="_blank" className='section-link' href={ this.removeHTMLtags( this.props.cms['about-marketplace-section-4-link'] ) } >
                            { this.props.cms['about-marketplace-section-4-link-text'] }
                        </a>
                    </p>           
                </div>                
            </div> 

            <div className='section-5' >
                <div className='text-wrap' >
                    <h2> { this.props.cms['about-marketplace-section-5-heading'] } </h2>
                    <p dangerouslySetInnerHTML={{ __html:  this.props.cms['about-marketplace-section-5-text']  }} /> 
                    <p>
                        <a target="_blank" className='section-link' href={ this.removeHTMLtags( this.props.cms['about-marketplace-section-5-link'] ) } >
                            { this.removeHTMLtags( this.props.cms['about-marketplace-section-5-link-text'] ) }
                        </a>
                    </p>           
                </div>
                <div className='img-wrap' >
                    <LazyImage src={  this.removeHTMLtags( this.props.cms['about-marketplace-section-5-image'] )  }  className='section-5-img' />
                </div>
            </div>

            <div className='section-6' >
                <div className='img-wrap' >
                    <LazyImage src={  this.removeHTMLtags( this.props.cms['about-marketplace-section-6-image'] )  }  className='section-6-img' />
                </div> 
                <div className='text-wrap' >
                    <h2> { this.removeHTMLtags( this.props.cms['about-marketplace-section-6-heading'] )} </h2>
                    <p dangerouslySetInnerHTML={{ __html:  this.props.cms['about-marketplace-section-6-text']  }} /> 
                    <p>
                        <a target="_blank" className='section-link' href={ this.removeHTMLtags( this.props.cms['about-marketplace-section-6-link'] ) } >
                            { this.removeHTMLtags( this.props.cms['about-marketplace-section-6-link-text'] ) }
                        </a>
                    </p>           
                </div>                
            </div>             
          </div>
        </Wrapper>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  cms: state.app.cms,
})

export default connect(
  mapStateToProps,
  null
)(PuppyResources)
